export default "__VITE_ASSET__TJ9f8TiT__"